// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"260":"7fe77c13","300":"185a4052","352":"b1b74632"}[chunkId] + ".chunk.css";
};